// 场馆关注接口
import request from '@/utils/request'

// (已登录用户)获取场馆预约系统token
export function getVenueUserToken() {
  return request({
    method: 'get',
    url: '/cultureCantonDemoApi/token/getVenueUserToken',
  })
}

// 场馆列表-详情数据接口
export function getVenueData(data) {
  return request({
    url: '/venueReservationApiServer/venue/getDetailData',
    method: 'post',
    data,
  })
}

// 预约信息展示接口（预约天数）
export function getReservationDate(data) {
  return request({
    url: `/venueReservationApiServer/venueReservation/getReservationDate?venueId=${data.venueId}&type=${data.type}`,
    method: 'get',
  })
}

// 预约信息展示接口（预约时间段）
export function getReservationHour(data) {
  return request({
    url: `/venueReservationApiServer/venueReservation/getReservationHour?venueId=${data.venueId}&dateId=${data.dateId}`,
    method: 'get',
  })
}

// 获取预约须知
export function getKnowContent(data) {
  return request({
    url: `/venueReservationApiServer/venueReservation/getKnowContent?venueId=${data.venueId}`,
    method: 'get',
  })
}

// 预约人展示接口
export function getUserList() {
  return request({
    url: `/venueReservationApiServer/contactUser/getContactUserList`,
    method: 'get',
  })
}

// 预约人编辑接口
export function updateUser(data) {
  return request({
    url: `/venueReservationApiServer/contactUser/updateContactUser`,
    method: 'post',
    data,
  })
}

// 预约人删除接口
export function removeUser(data) {
  return request({
    url: `/venueReservationApiServer/contactUser/removeContactUser`,
    method: 'post',
    data,
  })
}

// 预约人保存接口
export function saveUser(data) {
  return request({
    url: `/venueReservationApiServer/contactUser/saveContactUser`,
    method: 'post',
    data,
  })
}

// 预约保存接口
export function saveVenueReservation(data) {
  return request({
    url: `/venueReservationApiServer/venueReservation/saveVenueReservation`,
    method: 'post',
    data,
  })
}

// 预约详情接口
export function getVenueReservationList(data) {
  return request({
    url: `/venueReservationApiServer/venueReservation/getVenueReservationList?reservationOrderId=${data.reservationOrderId}`,
    method: 'get',
  })
}

// 场地列表详情数据
export function getSiteData(data) {
  return request({
    url: '/venueReservationApiServer/site/getDetailData',
    method: 'post',
    data,
  })
}

// 场地预约当天详情信息
export function getDate(data) {
  return request({
    url: '/venueReservationApiServer/site/reserveNowDetail',
    method: 'post',
    data,
  })
}

// 场地预约时间详情信息
export function getHour(data) {
  return request({
    url: '/venueReservationApiServer/site/reserveHourDetail',
    method: 'post',
    data,
  })
}

// 获取预约须知
export function getKnowContentSite(data) {
  return request({
    url: `/venueReservationApiServer/siteReservation/getSiteKnowContent?siteId=${data.siteId}`,
    method: 'get',
  })
}

// 场地预约保存
export function saveData(data) {
  return request({
    url: `/venueReservationApiServer/siteReservation/saveData`,
    method: 'post',
    data,
  })
}

// 获取是否需要审批
export function getNeedAudit(data) {
  return request({
    url: `/venueReservationApiServer/site/getNeedAudit`,
    method: 'post',
    data,
  })
}
